import React from "react";
import { Container, Row } from "react-bootstrap";
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import CrearSedeClassicsIndividual from "./crear-sede-individual";
import CrearSedeClassicsMasivo from "./crear-sede-masivo";

const CrearSedeClassics = () => {
  return (
    <>
      <div className="mb-4 d-flex align-items-center">
        <div className="admin-page-tilte">(</div>
        <CreateOutlinedIcon />
        <div className="admin-page-tilte mr-2">)</div>
        <div className="admin-page-tilte">Agregar un nuevo Instituto</div>
      </div>
      <Container fluid>
        <Row>
          <CrearSedeClassicsIndividual />
          <CrearSedeClassicsMasivo />
        </Row>
      </Container>
    </>
  );
};

export default CrearSedeClassics;
